import { TYPE_LABELS } from '@/lib/projectConstants';

/**
 * The project type filter on the Projects page.
 *
 * The options are derived from TYPE_LABELS rather than typed out again, so a
 * fourth project type added there appears in the dropdown without this file
 * changing - and, more to the point, so the dropdown can never offer a type
 * the rest of the app does not know about.
 */
export const TYPE_FILTER_ALL = 'all';

/** The dropdown's options, in the order they are shown. */
export const TYPE_FILTER_OPTIONS = [
  { value: TYPE_FILTER_ALL, label: 'All Types' },
  ...Object.entries(TYPE_LABELS).map(([value, label]) => ({ value, label })),
];

/**
 * Does this project match the selected type?
 *
 * `all` matches everything, so the caller can pass the dropdown's value
 * straight through. A project with no type set matches only `all` - it is not
 * a Capital project just because Capital is listed first.
 */
export function matchesProjectType(project, filter) {
  if (!filter || filter === TYPE_FILTER_ALL) return true;
  return project?.type === filter;
}

/**
 * The same question asked of a whole list.
 *
 * Here rather than written out at each call site, because the Projects page
 * and the Dashboard both narrow a list of projects by type and the failure
 * mode of keeping the rule in both is that they drift - a project shown on one
 * page and not the other under the same setting.
 */
export function filterProjectsByType(projects, filter) {
  if (!filter || filter === TYPE_FILTER_ALL) return projects || [];
  return (projects || []).filter(p => matchesProjectType(p, filter));
}
